import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import {ToastContainer, toast } from "react-toastify";
import LoanPaymentChangePane from "./LoanPaymentChangePane";
import { getTrans as t } from "../../../../Localization/translations";
import { confirmAlert } from "react-confirm-alert"; // Import

export default function LoanModification({ contractId, contractdetails }) {
  const [openPane, setOpenPane] = useState(false);
  const [newInterestRate, setNewInterestRate] = useState("");
  const [draftId, setDraftId] = useState(null);
  const [modificationType, setModificationType] = useState("InterestRateChange");
  const [draftContract, setDraftContract] = useState(null);
  const [interestRateType, setInterestRateType] = useState("Fixed");
  const [baseRate, setBaseRate] = useState("");
  const [margin, setMargin] = useState("");
  console.log("CONTRACT DETAILS IN MOD", contractId);

  // const handlepayment = (state) => {
  //     let url = API + `contracts/contracts/${state}/loan-payment-schedule/`;
  //     axios
  //       .get(url, { headers: authHeader() })
  //       .then((response) => {
  //         // setItems(response.data.data);
  //       });
  //   };

    const [recalcVersion, setRecalcVersion] = useState(0);


    const recalcLoanSchedule = async (draftId) => {
  await axios.post(
    `${API}contracts/contracts/${draftId}/loan-payment-schedule/`,
    {},
    { headers: authHeader() }
  );
};
const submitInterestChange = async () => {
  if (!newInterestRate) {
    toast.error("Enter new interest rate");
    return;
  }

  try {
    // 1️⃣ Create / update draft
    const res = await axios.post(
      `${API}contracts/contracts/${contractId}/loan-modify/`,
      { new_interest_rate: parseFloat(newInterestRate),
        interest_rate_type: interestRateType,
        base_rate: interestRateType === "Floating" ? parseFloat(baseRate) : 0,
        margin: interestRateType === "Floating" ? parseFloat(margin) : 0,
       },
      { headers: authHeader() }
    );

    const draftId = res.data.draft_contract_id;
    setDraftId(draftId);

    // 2️⃣ WAIT for recalculation to COMPLETE
    await axios.post(
      `${API}contracts/contracts/${draftId}/loan-payment-schedule/`,
      {},
      { headers: authHeader() }
    );

    // 3️⃣ 🔥 FORCE REFRESH
    setRecalcVersion(v => v + 1);

    setOpenPane(true);
    toast.success("Interest updated & recalculated");

  } catch (e) {
    toast.error("Failed to update interest rate");
  }
};

const [mergedPaymentDetails, setMergedPaymentDetails] = useState([]);
const [amortData, setAmortData] = useState([]);

const activateLoanModification = async () => {
  if (!draftId) {
    toast.error("No draft available to activate");
    return;
  }

  try {
    await axios.post(
      `${API}contracts/contracts/${draftId}/loan-modification-activate/`,
      {
        items: mergedPaymentDetails,   // coming from pane
        amort: amortData               // pass amort data
      },
      { headers: authHeader() }
    );

    toast.success("Loan modification activated");
    // setOpenPane(true);

    // 🔄 reload page / parent contract
    window.location.reload();

  } catch (e) {
    toast.error("Failed to activate modification");
  }
};

console.log("MERGED PAYMENT DETAILS", mergedPaymentDetails);


  // const submitInterestChange = async () => {
  //   if (!newInterestRate) {
  //     toast.error("Enter new interest rate");
  //     return;
  //   }

  //   try {
  //     const res = await axios.post(
  //       `${API}contracts/contracts/${contractId}/loan-modify/`,
  //       {
  //         // amendment_type: "INTEREST_RATE_CHANGE",
  //         new_interest_rate: parseFloat(newInterestRate),
  //       },
  //       { headers: authHeader() }
  //     );

  //     setDraftId(res.data.draft_contract_id);
  //     handlepayment(res.data.draft_contract_id);
  //     toast.success("Interest rate change draft created");
  //     setOpenPane(true);
  //   } catch (e) {
  //     toast.error("Failed to create interest rate change");
  //   }
  // };

  // console.log("CONTRACT DETAILS IN MOD", draftId);
  // console.log("CONTRACT DETAILS IN MOD", draftContract);

  useEffect(() => {
    // setOpenPane(true);
    axios
      .get(`${API}contracts/contracts/${contractId}/versions/`, {
        headers: authHeader(),
      })
      .then((res) => {
        const versions = res.data.versions || [];
  
        // ✅ find latest ContractMod
        const draft = versions
          .filter(v => v.status === "ContractMod")
          .sort((a, b) => b.version - a.version)[0];

          console.log("LOAN MOD DRAFT", draft);
  
        // setDraftId(draft ? draft.id : null);
         if (!draftId && draft) {
        setDraftId(draft.id);
      }
  
        if (draft) {
          const contract =
  draft.contracts?.find(c => c.status === "ContractMod") ||
  draft.contracts?.find(c => c.id === draft.id) ||
  null;
          // const contract = draft.contracts?.[0] || null;
          console.log("CONTRACT IN DRAFT", contract); 
  
          setDraftContract(contract);
  
          // ✅ THESE come from VERSION, not contract
          // setTotalRent(draft.payment_rent_sum || 0);
          // setOneTimeFeeSum(draft.one_time_fee_sum || 0);
  
          setNewInterestRate(contract?.iir || 0);
          setInterestRateType(contract?.interest_rate_type || "Fixed");
          if (contract?.interest_rate_type === "Floating") {
            setBaseRate(contract?.base_rate || 0);
            setMargin(contract?.margin || 0);
          } else {
            setBaseRate(0);
            setMargin(0);
          }
          console.log("DRAFT CONTRACT IN MOD", contract?.iir);
        } else {
          setDraftContract(null);
          // setTotalRent(0);
          // setOneTimeFeeSum(0);
          setNewInterestRate(0);
          setInterestRateType("Fixed");
          setBaseRate(0);
            setMargin(0);
        }
      });
       
  }, [openPane,contractId,recalcVersion]);



//   const abandonContract = async () => {
//   if (!draftId) {
//     toast.error("No draft to delete");
//     return;
//   }

//   if (!window.confirm("Are you sure you want to abandon this contract modification?")) {
//     return;
//   }

//   try {
//     await axios.delete(
//       `${API}contracts/contractsmod/${draftId}/delete-mod/`,
//       { headers: authHeader() }
//     );

//     toast.success("Contract modification abandoned");

//     // Reset state
//     setDraftId(null);
//     setDraftContract(null);
//     setOpenPane(false);

//     // Reload to reflect changes
//     window.location.reload();

//   } catch (e) {
//     toast.error("Failed to delete contract modification");
//   }
// };

const abandonContract = async () => {
  if (!draftId) {
    toast.error("No draft to delete");
    return;
  }

  confirmAlert({
    title: "",
    message: "Are you sure you want to delete this amendment?",
    buttons: [
      {
        label: "Yes",
        onClick: async () => {
          try {
            await axios.delete(
              `${API}contracts/contractsmod/${draftId}/delete-mod/`,
              { headers: authHeader() }
            );

            toast.success("Amendment abandoned");

            // Reset state
            setDraftId(null);
            setDraftContract(null);
            setOpenPane(false);

            // Reload
            window.location.reload();

          } catch (e) {
            toast.error("Failed to delete Amendment");
          }
        },
      },
      {
        label: "No",
      },
    ],
  });
};

useEffect(() => {
  if (interestRateType === "Floating") {
    const total =
      (parseFloat(baseRate) || 0) + (parseFloat(margin) || 0);
    setNewInterestRate(total);
  }
}, [baseRate, margin, interestRateType]);


  return (
    <>
    <div className="container-fluid px-3 ">

       <ToastContainer />
            {/* Modification Type Selector */}
            {/* <div className="card mt-3 ">
              <div className="card-body col-md-4">
                <label className="col-xl-6 col-form-label">{t("Modification Type")}</label>
      
                <select
                  className="form-control col-xl-4"
                  value={modificationType}
                  onChange={(e) => setModificationType(e.target.value)}
                  disabled
                >
                  <option value="">Select</option>
                  <option value="ExtendTerm">{t("Extend Term")}</option>
                  <option value="PaymentChange">{t("Payment Change")}</option>
                  {contractdetails?.contract_type === "Loan" && (
                    <option value="InterestRateChange">Interest Rate Change</option>
                  )}
      
                </select>
              </div>
            </div> */}
      
      {/* BUTTON – same place as Payment Change */}
      <div className="mt-3  card-body justify-content-end mb-3">
      {/* <div className="d-flex justify-content-end mb-3"> */}
        <button
          className="btn btn-primary"
          onClick={() => setOpenPane(true)}
        >
          Interest Rate Change
        </button>&nbsp;
         {draftId && (
        <button
           className="btn btn-secondary"
           onClick={abandonContract}
         >
           {/* Abandon Contract */}
           Delete
         </button>
       )}&nbsp;
         {/* 🔥 SAVE — only when ContractMod */}
  {draftId && (
    <button
      className=" btn btn-primary"
      onClick={activateLoanModification}
    >
      Activate
    </button>
  )}
             </div>



      {/* INTEREST INPUT */}
      {openPane && (
        <div className="card mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <label className="col-form-label">Current Interest Rate</label>
                <input
                  className="form-control"
                  value={contractdetails?.iir}
                  disabled
                />
              </div>

              {/* Interest Rate Type */}
  <div className="col-md-4">
    <label className="col-form-label">Interest Rate Type</label>

    <div className="d-flex gap-3 mt-2">
      <div className="form-check">
        <input
          type="radio"
          name="interestRateType"
          value="Fixed"
          className="form-check-input"
          checked={interestRateType === "Fixed"}
          onChange={(e) => setInterestRateType(e.target.value)}
        />
        <label className="form-check-label">Fixed</label>
      </div>

      <div className="form-check">
        <input
          type="radio"
          name="interestRateType"
          value="Floating"
          className="form-check-input"
          checked={interestRateType === "Floating"}
          onChange={(e) => setInterestRateType(e.target.value)}
        />
        <label className="form-check-label">Floating</label>
      </div>
    </div>
  </div>

  {/* Fixed Input */}
  {interestRateType === "Fixed" && (
    <div className="col-md-4">
      <label className="col-form-label">New Interest Rate (%)</label>
      <input
          type="number"
          step="0.01"
          placeholder="Interest rate"
          className="form-control"
          value={newInterestRate}
          onChange={(e) => setNewInterestRate(e.target.value)}
        />
    </div>
  )}

  {/* Floating Inputs */}
  {interestRateType === "Floating" && (
    <>
      <div className="col-md-4">
        <label className="col-form-label">Base Rate (%)</label>
        <input
          type="number"
          step="0.01"
          className="form-control"
          value={baseRate}
          onChange={(e) => setBaseRate(e.target.value)}
          onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
          onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();              // ✅ disables up/down arrow change
              }
          }}
        />
      </div>

      <div className="col-md-4">
        <label className="col-form-label">Margin (%)</label>
        <input
          type="number"
          step="0.01"
          className="form-control"
          value={margin}
          onChange={(e) => setMargin(e.target.value)}
          onWheel={(e) => e.target.blur()}     // ✅ disables scroll change
          onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();              // ✅ disables up/down arrow change
              }
          }}
        />
      </div>

      <div className="col-md-4">
        <label className="col-form-label">New Interest Rate (%)</label>
        <input
          className="form-control"
          value={newInterestRate}
          disabled
        />
      </div>
    </>
  )}

              {/* <div className="col-md-6">
                <label className="col-form-label">New Interest Rate (%)</label>
                <input
                  type="number"
                  step="0.01"
                  placeholder="Interest rate"
                  className="form-control"
                  value={newInterestRate}
                  onChange={(e) => setNewInterestRate(e.target.value)}
                />
              </div> */}
            </div>

            <button
              className="btn btn-primary mt-3"
              onClick={submitInterestChange}
            >
              Save
            </button>
          </div>
        </div>
      )}

      {/* DISPLAY SCHEDULES */}
      {/* {draftId && ( */}
        <LoanPaymentChangePane
          contractId={contractId}
          draftId={draftId}
          recalcVersion={recalcVersion}
           onReadyToSave={(rows, amort) => {
    setMergedPaymentDetails(rows);
    setAmortData(amort);
  }}

        />
      {/* )} */}
      </div>
    </>
  );
}
